import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',             to: '/',                  type: 'route' },
  { label: 'Expertise',        to: '/#expertise',        type: 'anchor' },
  { label: 'Epistemology',     to: '/#epistemology',     type: 'anchor' },
  { label: 'Company',          to: '/company',           type: 'route' },
  { label: 'Causal Extractor', to: '/causal-extractor',  type: 'route' },
  { label: 'Contact',          to: '/contact',           type: 'route' },
];

const Footer = () => {
  const location = useLocation();

  const handleAnchorClick = (e, href) => {
    const hash = href.split('#')[1];
    if (location.pathname === '/') {
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    // Otherwise let the browser navigate to /#hash naturally
  };

  return (
    <footer className="bg-[#030608]">
      {/* Top accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" />

      <div className="px-6 md:px-10 py-14 md:py-16">
      <div className="max-w-7xl mx-auto">

        {/* Main grid: brand (wider) | contact | office */}
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr] gap-0 md:gap-12">

          {/* Brand column */}
          <div className="text-center md:text-left pb-10 md:pb-0 border-b border-white/[0.05] md:border-b-0">
            <Link to="/" className="inline-flex items-center gap-3 mb-5">
              <img src="/NN-logo-1.svg" alt="Nordic Numbers" className="h-8 w-auto" />
              <div className="flex flex-col leading-none">
                <span className="font-bold text-white tracking-tight text-base">Nordic</span>
                <span className="font-bold text-blue-400 tracking-tight text-base">Numbers</span>
              </div>
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed mb-7 max-w-sm mx-auto md:mx-0">
              Specialists in causal analysis for complex domains. We help you understand not just
              what happens, but why, and how to act on it.
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-6 gap-y-3">
              {NAV_LINKS.map(({ label, to, type }) =>
                type === 'anchor' ? (
                  <a
                    key={to}
                    href={to}
                    onClick={(e) => handleAnchorClick(e, to)}
                    className="text-[0.72rem] font-semibold uppercase tracking-[0.18em] text-slate-600 hover:text-blue-400 transition-colors duration-200"
                  >
                    {label}
                  </a>
                ) : (
                  <Link
                    key={to}
                    to={to}
                    className="text-[0.72rem] font-semibold uppercase tracking-[0.18em] text-slate-600 hover:text-blue-400 transition-colors duration-200"
                  >
                    {label}
                  </Link>
                )
              )}
            </div>
          </div>

          {/* Contact column */}
          <div className="text-center md:text-right pt-10 pb-10 md:pt-0 md:pb-0 border-b border-white/[0.05] md:border-b-0">
            <h4 className="text-[0.67rem] font-bold uppercase tracking-[0.22em] text-slate-600 mb-5">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+4794824472"
                  className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
                >
                  +47 948 24 472
                </a>
              </li>
              <li>
                <a
                  href="mailto:jone@nordicnumbers.no"
                  className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
                >
                  jone@nordicnumbers.no
                </a>
              </li>
              <li className="pt-2 flex justify-center md:justify-end">
                <a
                  href="https://www.linkedin.com/company/nordic-numbers/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors duration-200 group"
                >
                  LinkedIn
                  <img
                    src="/basil_linkedin-outline.svg"
                    alt="LinkedIn"
                    className="h-4 w-4 invert opacity-50 group-hover:opacity-90 transition-opacity duration-200"
                  />
                </a>
              </li>
            </ul>
          </div>

          {/* Office column */}
          <div className="text-center md:text-right pt-10 md:pt-0">
            <h4 className="text-[0.67rem] font-bold uppercase tracking-[0.22em] text-slate-600 mb-5">Office</h4>
            <address className="not-italic text-sm text-slate-400 space-y-1 leading-relaxed">
              <p>Fyllingsveien 22</p>
              <p>5160 Bergen</p>
              <p>Norway</p>
            </address>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-5 border-t border-white/[0.05] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-700">
            © {new Date().getFullYear()} Nordic Numbers. All rights reserved.
          </p>
          <p className="text-xs text-slate-700">Bergen, Norway</p>
        </div>

      </div>
      </div>
    </footer>
  );
};

export default Footer;
